import { useBehavior, useTriggerAction, useUpdateWidgetValue } from '@libs/hooks';
import { ActionActionTypeEnum, TWidget } from '@libs/types';
import React from 'react';
import { TSelectorRegularData } from '../../../types/data';
import { TRowOption, TSelectorRegularOption } from '../../../types/options';
import { RowRegularView } from './RowRegularView';

type TRowRegularWidgetProps = {
    widget: TWidget<TSelectorRegularData, TRowOption & TSelectorRegularOption>;
};

export const RowRegularWidget = ({ widget }: TRowRegularWidgetProps) => {
    const { updateWidgetValue } = useUpdateWidgetValue(widget);
    const { triggerActionsByType } = useTriggerAction(widget);
    const { isDisabled, isHidden } = useBehavior(widget);

    const parentStyleNames = [widget.options?.style].filter(Boolean) as string[];

    const handleAction = () => {
        updateWidgetValue(!widget.data.value);
        triggerActionsByType(ActionActionTypeEnum.onClick).then();
    };

    return (
        <RowRegularView
            widget={widget}
            isDisabled={isDisabled}
            isHide={isHidden}
            handleClick={handleAction}
            parentStyleNames={parentStyleNames}
        />
    );
};
